import React, { useContext } from "react";
import { Icon, List } from "rbx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useApolloClient } from "react-apollo";

import { useCurrentUser } from "../../../utils/hooks";
import { logout } from "../../Logout";

import { ModalContext } from "../../ModalProvider";

import { ChangePasswordForm } from "../../Users";

import "./UserActionButton.scss";

const UserActionButton = () => {
  const { setModalOpen } = useContext(ModalContext);

  const client = useApolloClient();

  const { data: user, loading: userLoading } = useCurrentUser();

  const handleLogout = () => {
    logout(client);
  };

  const handleChangePassword = () => {
    setModalOpen(
      true,
      <ChangePasswordForm
        user={user}
        onComplete={() => setModalOpen(false, "")}
      />
    );
  };
  return (
    <div className="sidebar-menu-item bottom user-actions-container">
      <Icon size="large">
        <FontAwesomeIcon icon="sign-out-alt" />
      </Icon>
      <span>{userLoading ? "Logout" : user.UserId}</span>
      <div className="user-actions-list">
        <List>
          <List.Item onClick={handleChangePassword}>Change Password</List.Item>
          <List.Item onClick={handleLogout}>Logout</List.Item>
        </List>
      </div>
    </div>
  );
};

export default UserActionButton;
